import { useQuery } from '@tanstack/react-query';
import { ApiCompanyAndContactsRepository } from 'services/company-and-contacts/ApiCompanyAndContactsRepository';
import { QueryKeys } from 'utils/queryKeys';

import type { CompositeEntityId } from 'services/company-and-contacts/mappers';

export const useGetCrmContactByIdQuery = (contactId: CompositeEntityId | undefined | null, options: { enabled?: boolean } = {}) => {
  const { enabled = true } = options;
  return useQuery({
    queryKey: QueryKeys.getCrmContactById(contactId),
    queryFn: () => (contactId ? ApiCompanyAndContactsRepository.getCrmContactById(contactId) : Promise.reject(new Error('invalid id'))),
    enabled: enabled && !!contactId,
  });
};
